import { Directive, EmbeddedViewRef, Injector, Input, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[boschUiCellDef]',
})
export class BoschUiCellDefDirective<DataType> extends TemplateRef<DataType> {
  @Input() set boschUiCellDef(context: DataType) {
    this.viewContainer.clear();
    this.viewContainer.createEmbeddedView(this.templateRef, context);
  }
  elementRef = this.templateRef.elementRef;

  constructor(public templateRef: TemplateRef<DataType>, public viewContainer: ViewContainerRef) {
    super();
  }

  override createEmbeddedView(context: DataType, injector?: Injector): EmbeddedViewRef<DataType> {
    return this.templateRef.createEmbeddedView(context, injector);
  }
}
